import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import CastingServices from "../../../services/CastingService";
import Swal from "sweetalert2";

const CastingDigital = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [formNumber, setFormNumber] = useState("");
    const [requestType, setRequestType] = useState("mrv");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [headindData, setHeadingData] = useState('')

    const handleSearch = async () => {
        if (!formNumber) {
            Swal.fire("Error", "Please enter form number", "error");
            return;
        }

        setReportData([]);
        setLoading(true);

        try {
            const res = await CastingServices.CastingDigitalReport({
                no: formNumber,
                type: requestType,
            });

            const responseData = Array.isArray(res?.data) ? res.data : [];
            setHeadingData(res?.matched)
            console.log(res.matched)
            setReportData(responseData);
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const renderTableContent = () => {
        if (requestType === "mrv") {
            return (
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Request No.</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Apporved Qty</th>
                        <th>Casting Qty</th>
                        <th>Qty After Casting</th>
                        <th>Unit</th>
                    </tr>
                </thead>
            );
        } else {
            return (
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Request No.</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Apporved Qty</th>
                        <th>Casting Qty</th>
                        <th>Qty After Casting</th>
                        <th>Unit</th>
                    </tr>
                </thead>
            );
        }
    };

    const handlePrint = () => {
        const items = reportData;
        const documentUser = { user: { name: "Store Staff" } };

        const generateHTML = () => {
            if (requestType === "mrv") {
                return `
              
    <div style="max-width: 1024px; margin: 0 auto; background-color: white; padding: 24px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
            <div>
                <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
                <p style="font-size: 0.875rem;">3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17, Dwarka</p>
                <p style="font-size: 0.875rem;">New Delhi - 110 075, Ph : +91-11-4572 0141 / 4445 8664</p>
            </div>
            <p style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.1rem; font-weight: bold; color:black;">
            DIGITAL COPY
          </p>
            <div style="text-align: right;">
                <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Indigo Infraprojects Pvt. Ltd. logo" style="margin-bottom: 8px; width: 100px; height: 50px;"/>
                <h2 style="text-align: center; font-size: 1.125rem; font-weight: bold; margin-bottom: 1rem;">MATERIAL RECEIPT VOUCHER (CASTING)</h2>

            </div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
            <div>
              <p>MRV No.: <span style="font-weight: bold;">${headindData?.RequestNo}</span></p>
                <p>Supplier Name : ........................................</p>
                <p>Bill No. / DC No. : .......................................</p>
            </div>
            <div>
                <p>Project Code : ........................................</p>
                <p>Project Name : ${headindData?.storeName}</p>
                <p>Location : ..............</strong></p>
                <p>Date :<strong>${new Date(headindData?.createdAt).toLocaleDateString('en-GB')}</strong></p>
            </div>
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #cbd5e0; margin-bottom: 16px;">
            <thead>
                <tr>
                    <th style="border: 1px solid #cbd5e0; padding: 8px;">S.No</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Request No.</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Part No</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Description</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Qty Approved</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Casting Qty</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Final Qty after Casting</th>
<th style="border: 1px solid #cbd5e0; padding: 8px;">Unit</th>
                </tr>
            </thead>
            <tbody>
                <!-- Repeat this row as needed -->
                ${reportData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; height: 32px;">${index + 1}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${headindData?.RequestNo}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.masterItem?.partNo}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.masterItem?.description}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.approveQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.castingQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${Math.max(
                    0,
                    (Number(item?.approveQty) || 0) +
                    (Number(item?.castingQty) || 0)
                )}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.unitName}</td>

                </tr>
                `).join('')}
                
            </tbody>
        </table>
        <div style="display: flex; justify-content: space-between;">
            <div>
                <p>Signature &amp; Name</p>
            </div>
            <div>
                <p>Prepared By: <strong>${headindData?.user?.name}</strong></p>
            </div>
            <div>
                <p>Date:<strong>${new Date(headindData?.createdAt).toLocaleDateString('en-GB')}</strong></p>
            </div>
            <div>
                <p>Signature &amp; Name</p>
            </div>
            <div>
                <p>Approved By</p>
            </div>
            <div>
                <p>Date</p>
            </div>
        </div>
    </div>
  `;
            } else {
                return `

    <div style="max-width: 64rem; margin: 0 auto; background-color: white; padding: 1.5rem; border: 1px solid #d1d5db;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <div>
                <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
                <p>3rd Floor, Plot No. - 12/B, Pocket 3, Sector – 17, Dwarka</p>
                <p>New Delhi – 110 075</p>
                <p>Ph : +91-11-4572 0741, 4445 8664</p>
            </div>
            <div>
                <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Company Logo" style="height: 3rem;"/>
            </div>
        </div>
        <h2 style="text-align:right; font-size: 1.125rem; font-weight: bold; margin-bottom: 1rem;">MATERIAL ISSUES VOUCHER(CASTING)</h2>
                                        <h4 style="text-align: center; font-size: 1.125rem; font-weight: bold; margin-bottom: 1rem;">DIGITAL COPY</h4>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem;">
            <div>
                <p>MIV No. : <strong>${headindData?.RequestNo}</strong></p>
                <p>Machine : <strong></strong></p>
                <p>MIV Date : <strong>....</strong></p>
                <p>Request By : <strong>.....</strong></p>
            </div>
            <div>
                <p>Project Code : <strong></strong></p>
                <p>Project Name : <strong>${headindData?.storeName}</strong></p>
                <p>Location : <strong>.....</strong></p>
                <p>Date : <strong>${new Date(headindData?.createdAt).toLocaleDateString('en-GB')}</strong></p>
            </div>
        </div>

<table style="width: 100%; border-collapse: collapse; border: 1px solid #cbd5e0; margin-bottom: 16px;">
            <thead>
                <tr>
                    <th style="border: 1px solid #cbd5e0; padding: 8px;">S.No</th>
                    <th style="border: 1px solid #cbd5e0; padding: 8px;">Part No</th>
                    <th style="border: 1px solid #cbd5e0; padding: 8px;">Description</th>
                    <th style="border: 1px solid #cbd5e0; padding: 8px;">Qty Approved</th>
                     <th style="border: 1px solid #cbd5e0; padding: 8px;">Casting Qty</th>
                     <th style="border: 1px solid #cbd5e0; padding: 8px;">Qty After Casting</th>
                      <th style="border: 1px solid #cbd5e0; padding: 8px;">Unit</th>
                </tr>
            </thead>
            <tbody>
                <!-- Repeat this row as needed -->
                ${reportData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; height: 32px;">${index + 1}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.masterItem?.partNo}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.masterItem?.description}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.approveQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.castingQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;">${Math.max(
                    0,
                    (Number(item?.approveQty) || 0) +
                    (Number(item?.castingQty) || 0)
                )}</td>
                      <td style="border: 1px solid #cbd5e0; padding: 8px;">${item?.unitName}</td>

                </tr>
                `).join('')}
                
            </tbody>
        </table>
        <div style="display: flex; justify-content: space-between; margin-top: 1rem;">
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Approved By ${headindData?.user?.name}</p>
            </div>
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Stores Officer</p>
            </div>
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Received By</p>
            </div>
        </div>
    </div>
`;
            };
        };

        const htmlContent = `
        <html lang="en">
        <head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
      <title>Print ${requestType.toUpperCase()}</title>
    <script src="https://cdn.tailwindcss.com"></script>
</head>
        
     <body style="background-color: #f3f4f6; padding: 1rem; font-family: Arial, sans-serif;">
            ${generateHTML()}
            
        </body>
        </html>`;

        const newWindow = window.open("", "_blank");
        newWindow.document.write(htmlContent);
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className="content-title">
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to="#"
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className={`fas ${open ? "fa-angle-down" : "fa-angle-up"}`}></i>
                            </Link>
                        </div>
                    </div>

                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Enter Form Number</label>
                                        <input
                                            type="number"
                                            className="form-control mb-xxl-0 mb-3"
                                            placeholder="Enter Form Number"
                                            value={formNumber}
                                            onChange={(e) => setFormNumber(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Select Request Type</label>
                                        <select
                                            className="form-select"
                                            style={{ height: "55px" }}
                                            value={requestType}
                                            onChange={(e) => setRequestType(e.target.value)}
                                        >
                                            <option value="mrv">Material Receipt Voucher (MRV)</option>
                                            <option value="miv">Material Issue Voucher (MIV)</option>
                                        </select>
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Search</label>
                                        <button
                                            className="form-control btn btn-primary"
                                            onClick={handleSearch}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Search"}
                                        </button>
                                    </div>

                                    <div className="col-xl-3 col-xxl-3 mt-4">
                                        <button
                                            className="btn btn-success w-100"
                                            onClick={handlePrint}
                                            disabled={reportData.length === 0}
                                        >
                                            Print
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary mt-1">
                    <div className="content-title">
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>
                            {requestType === "miv" ? "MIV" : "MRV"}{" "}
                            <span className="badge bg-orange ms-2">{reportData.length}</span>
                        </div>
                        <div className="tools">
                            <Link
                                to="#"
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className={`fas ${open2 ? "fa-angle-down" : "fa-angle-up"}`}></i>
                            </Link>
                        </div>
                    </div>

                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        {renderTableContent()}

                                        <tbody>
                                            {reportData.length > 0 ? (
                                                reportData.map((item, index) => {
                                                    const approved = Number(item?.approveQty) || 0;
                                                    const casting = Number(item?.castingQty) || 0;

                                                    const finalQty = Math.max(0, approved + casting);

                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item?.RequestNo}</td>
                                                            <td>{item?.masterItem?.partNo || ""}</td>
                                                            <td>{item?.masterItem?.description || ""}</td>
                                                            <td>{item?.approveQty}</td>
                                                            <td>{item?.castingQty}</td>
                                                            <td>{finalQty}</td>
                                                            <td>{item?.masterItem?.unit?.name || ""}</td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>
    );

};

export default CastingDigital;
